// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3k8Xa","ranges":"BmiRanges_ranges__3Gl7J"};